module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-map__wrapper"
  }, [_c('div', {
    staticClass: "ksm-map__page"
  }, [_c('div', {
    ref: "map-container",
    staticClass: "ksm-map__container"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm_map_infobox_container ksm-display-none"
  }, [_vm._l((_vm.fensterDataCollection), function(fensterData) {
    return [_c('div', {
      key: fensterData.type + '_' + fensterData.stadtindex,
      staticClass: "ksm-map__fenster",
      class: (!fensterData.visible && (fensterData.infoItem ? !fensterData.infoItem.fixied : true)) || (fensterData.type === 'ortsFenster' && fensterData.infoItems.length < 1) ? 'ksm-display-none' : '',
      attrs: {
        "data-stadtindex": fensterData.type + '_' + fensterData.stadtindex
      },
      on: {
        "mousedown": function($event) {
          return _vm.fensterMouseDown(fensterData, $event)
        }
      }
    }, [_c('div', {
      staticClass: "ksm-map__fenster-header"
    }, [_c('div', {
      staticClass: "ksm-flex-y-center"
    }, [(fensterData.infoItem) ? _c('div', {
      staticClass: "ksm-map__fenster-item-icon",
      style: ('background-color:' + fensterData.infoItem.accor.color)
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-title"
    }, [_vm._v(_vm._s(fensterData.stadtname))])]), _vm._v(" "), _c('div', {
      staticClass: "ksm-flex"
    }, [(fensterData.type === 'infoFenster') ? _c('div', {
      staticClass: "ksm-flex-y-center",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "ksm-map__fenster-header-arror",
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg('arrow-left-2.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.navigatorInfoFenster(fensterData, -1)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-header-arror",
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg('arrow-right-2.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.navigatorInfoFenster(fensterData, 1)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-close",
      on: {
        "click": function($event) {
          return _vm.closeFenster(fensterData)
        }
      }
    }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-body"
    }, [(fensterData.type === 'ortsFenster') ? _vm._l((fensterData.infoItems), function(infoItem, j) {
      return _c('div', {
        key: infoItem.row.docID + '' + j,
        staticClass: "ksm-map__fenster-item"
      }, [_c('div', {
        staticClass: "ksm-map__fenster-item-icon",
        style: ('background-color:' + infoItem.accor.color)
      }), _vm._v(" "), _c('a', {
        staticStyle: {
          "color": "#000"
        },
        on: {
          "mousedown": function($event) {
            return _vm.startClick($event)
          },
          "click": function($event) {
            return _vm.clickInfoItem(infoItem, $event)
          }
        }
      }, [_vm._v(_vm._s(infoItem.row._datvon) + " " + _vm._s(infoItem.row.ortsname))])])
    }) : _vm._e(), _vm._v(" "), (fensterData.infoItem) ? [_c('div', {
      staticClass: "ksm-flex-1"
    }, [(['Ausstellungen', 'Zeitschriften', 'Publikationen', 'Institution'].indexOf(fensterData.infoItem.row.Kategorie) > -1) ? _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.titel))]) : _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.ortsname))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.doc['113_titel']))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row._datvon) + _vm._s(fensterData.infoItem.row._datbis ? (' – ' + fensterData.infoItem.row._datbis) : ''))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.doc['113_personen'] ? ('Personen: ' + fensterData.infoItem.row.doc['113_personen'].map(function (p) { return p.content; }).join('; ')) : ''))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.doc['113_instutionen'] ? ('Institutionen: ' + fensterData.infoItem.row.doc['113_instutionen'].map(function (p) { return p.content; }).join(', ')) : ''))]), _vm._v(" "), _c('div', {
      staticClass: "ksm-hyphens ksm-disable-select",
      staticStyle: {
        "overflow": "auto",
        "margin-top": "5px"
      },
      domProps: {
        "innerHTML": _vm._s(fensterData.infoItem.row.full_113_html)
      }
    })])] : _vm._e()], 2)])]
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "ksm-map__control-btn alle-ortsfenster-schliessen",
    attrs: {
      "title": "Alle Ortsfenster schließen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('alle-ortsfenster-schliessen.svg'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-map__control-btn alle-infofenster-schliessen",
    attrs: {
      "title": "Alle Infofenster schließen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('alle-infofenster-schliessen.svg'))
    }
  })])], 2)]), _vm._v(" "), (!_vm.option.hideTimeline) ? _c('div', {
    staticClass: "ksm-map__timeline-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('TimelineView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarRightList[0].isExpand === true || _vm.sidebarRightList[1].isExpand === true),
      expression: "sidebarRightList[0].isExpand===true|| sidebarRightList[1].isExpand===true"
    }],
    attrs: {
      "splitLayoutResize": _vm.option.splitLayoutResize,
      "activeInfoItem": _vm.activeInfoItem,
      "infoItemList": _vm.timelineViewInput
    },
    on: {
      "clickInfoItem": _vm.clickInfoItem,
      "changeDate": _vm.changeDate
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "220px",
      "background-color": "#eee",
      "text-align": "center",
      "padding": "0 5px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://daeh.uni-trier.de/",
      "target": "_blank"
    }
  }, [_vm._v("© Karte 1928 aus Digital Atlas of European Historiography")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a2f988","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapView.vue
// module id = 1952
// module chunks = 1